import { render } from "./TextareaAnswer.vue?vue&type=template&id=59b97a6a"
import script from "./TextareaAnswer.vue?vue&type=script&lang=js"
export * from "./TextareaAnswer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__